import * as Yup from 'yup';
import { DeclarationDocumentResponse as CmsFile } from 'store/declarations/declaration';
import {
    documentFormValidationSchemaCommon,
    documentFormValidationSchemaAes,
    documentFormValidationSchemaAis,
    documentFormValidationSchemaNcts,
} from 'views/declarations/common/confirm-document-modal/file-validation.schema';
import { DeclarationDocument } from './types';

export const isDeclarationDocumentComplete = (
    cmsFile: CmsFile,
    declarationDocument: DeclarationDocument | undefined,
    isAes: boolean,
    isAis: boolean,
    isNcts: boolean
): boolean => {
    if (!declarationDocument) return false;

    const documentFormValidationSchema = Yup.object().shape({
        ...documentFormValidationSchemaCommon,
        ...(isAes
            ? documentFormValidationSchemaAes
            : isAis
            ? documentFormValidationSchemaAis
            : documentFormValidationSchemaNcts),
    });

    return documentFormValidationSchema.isValidSync({
        ...declarationDocument.fileInfo,
        filename: cmsFile.filename,
        documentType: declarationDocument.fileInfo?.documentType,
    });
};
